@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.onboarding.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.onboarding.resources/"

@delegate:ResourceContentHash(242_916_851)
internal val Res.string.onboarding_body: StringResource by lazy {
      StringResource("string:onboarding_body", "onboarding_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 267),
      ))
    }

@delegate:ResourceContentHash(1_538_691_496)
internal val Res.string.onboarding_disclaimer: StringResource by lazy {
      StringResource("string:onboarding_disclaimer", "onboarding_disclaimer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278, 225),
      ))
    }

@delegate:ResourceContentHash(1_007_155_848)
internal val Res.string.onboarding_headline_find: StringResource by lazy {
      StringResource("string:onboarding_headline_find", "onboarding_headline_find", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 504, 56),
      ))
    }

@delegate:ResourceContentHash(-240_000_078)
internal val Res.string.onboarding_headline_share: StringResource by lazy {
      StringResource("string:onboarding_headline_share", "onboarding_headline_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 561, 61),
      ))
    }

@delegate:ResourceContentHash(1_938_610_195)
internal val Res.string.onboarding_location_allow: StringResource by lazy {
      StringResource("string:onboarding_location_allow", "onboarding_location_allow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 623, 49),
      ))
    }

@delegate:ResourceContentHash(1_556_647_702)
internal val Res.string.onboarding_location_body: StringResource by lazy {
      StringResource("string:onboarding_location_body", "onboarding_location_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 240),
      ))
    }

@delegate:ResourceContentHash(1_564_747_695)
internal val Res.string.onboarding_location_later: StringResource by lazy {
      StringResource("string:onboarding_location_later", "onboarding_location_later", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 914, 45),
      ))
    }

@delegate:ResourceContentHash(-1_953_757_385)
internal val Res.string.onboarding_location_title: StringResource by lazy {
      StringResource("string:onboarding_location_title", "onboarding_location_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 960, 49),
      ))
    }

@delegate:ResourceContentHash(-250_365_993)
internal val Res.string.onboarding_login: StringResource by lazy {
      StringResource("string:onboarding_login", "onboarding_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1010, 52),
      ))
    }

@delegate:ResourceContentHash(-1_075_629_345)
internal val Res.string.onboarding_start: StringResource by lazy {
      StringResource("string:onboarding_start", "onboarding_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1063, 52),
      ))
    }

@delegate:ResourceContentHash(-1_299_463_033)
internal val Res.string.onboarding_step_place: StringResource by lazy {
      StringResource("string:onboarding_step_place", "onboarding_step_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1116, 77),
      ))
    }

@delegate:ResourceContentHash(647_792_465)
internal val Res.string.onboarding_step_share: StringResource by lazy {
      StringResource("string:onboarding_step_share", "onboarding_step_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1194, 89),
      ))
    }

@delegate:ResourceContentHash(1_321_077_031)
internal val Res.string.onboarding_step_spot: StringResource by lazy {
      StringResource("string:onboarding_step_spot", "onboarding_step_spot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1284, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("onboarding_body", Res.string.onboarding_body)
  map.put("onboarding_disclaimer", Res.string.onboarding_disclaimer)
  map.put("onboarding_headline_find", Res.string.onboarding_headline_find)
  map.put("onboarding_headline_share", Res.string.onboarding_headline_share)
  map.put("onboarding_location_allow", Res.string.onboarding_location_allow)
  map.put("onboarding_location_body", Res.string.onboarding_location_body)
  map.put("onboarding_location_later", Res.string.onboarding_location_later)
  map.put("onboarding_location_title", Res.string.onboarding_location_title)
  map.put("onboarding_login", Res.string.onboarding_login)
  map.put("onboarding_start", Res.string.onboarding_start)
  map.put("onboarding_step_place", Res.string.onboarding_step_place)
  map.put("onboarding_step_share", Res.string.onboarding_step_share)
  map.put("onboarding_step_spot", Res.string.onboarding_step_spot)
}
